import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const endPoint = 'getSlackChannels/';
const url = apiUrl + endPoint;

export interface SlackChannel {
  ChannelId: string;
  ChannelName: string;
  Subscriptions: string[]; // e.g., ['PR', 'Sprint', 'OSS']
  IsBotMember: boolean;
  IsPrivate?: boolean;
}

export interface GetSlackChannelsRequest {
  OrgUUID: string;
}

export interface GetSlackChannelsResponse {
  Error: string | null;
  Channels: SlackChannel[];
  WorkspaceName: string | null;
  WorkspaceDomain?: string | null; // Subdomain for workspace URL (e.g. "mycompany" -> mycompany.slack.com)
  WorkspaceIcon?: string | null; // team.info icon URL; null when Slack returns its default auto-icon
}

const getSlackChannels = async (
  req: GetSlackChannelsRequest,
  headerObj: headerObject
): Promise<GetSlackChannelsResponse | null> => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data;
  } catch (err) {
    console.error('Error fetching Slack channels:', err);
    return null;
  }
};

export default getSlackChannels;
